import { useEffect } from "react";
import { useParams, Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
const SUPPORTED_LANGUAGES = ["en", "uk", "ru"];
const DEFAULT_LANGUAGE = "en";

export const LanguageWrapper = () => {
  const { lang } = useParams<{ lang: string }>();
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  }, [lang, i18n]);

  if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
    const savedLang = localStorage.getItem("i18nextLng") || DEFAULT_LANGUAGE;
    const targetLang = SUPPORTED_LANGUAGES.includes(savedLang)
      ? savedLang
      : DEFAULT_LANGUAGE;

    const newPath = `/${targetLang}${location.pathname}`;
    return <Navigate to={`${newPath}${location.search}`} replace />;
  }

  return (
    <>
      <Helmet>
        <title>
          {t("common:meta_title", "Kemblo | Advanced Analytics & Tracking")}
        </title>
        <meta
          name="description"
          content={t(
            "common:meta_description",
            "The ultimate workspace for media buyers. Manage campaigns, analyze traffic, and optimize your ROI with precision.",
          )}
        />
        <meta
          property="og:title"
          content={t(
            "common:meta_title",
            "Kemblo | Advanced Analytics & Tracking",
          )}
        />
        <meta
          property="og:description"
          content={t(
            "common:meta_description",
            "The ultimate workspace for media buyers. Manage campaigns, analyze traffic, and optimize your ROI with precision.",
          )}
        />
        <meta
          property="twitter:title"
          content={t(
            "common:meta_title",
            "Kemblo | Advanced Analytics & Tracking",
          )}
        />
        <meta
          property="twitter:description"
          content={t(
            "common:meta_description",
            "The ultimate workspace for media buyers. Manage campaigns, analyze traffic, and optimize your ROI with precision.",
          )}
        />
      </Helmet>
      <Outlet />
    </>
  );
};

export const RootRedirect = () => {
  const savedLang = localStorage.getItem("i18nextLng") || DEFAULT_LANGUAGE;
  const finalLang = SUPPORTED_LANGUAGES.includes(savedLang)
    ? savedLang
    : DEFAULT_LANGUAGE;

  return <Navigate to={`/${finalLang}`} replace />;
};
